
import { isEmpty, split, head, isNil, get } from 'lodash';
import { required, email, minValue, maxValue, numeric, decimal, alpha, alphaNum, integer, not, helpers, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';

// define a mixin object
export default {

  props: {
    parentErrors: {
      default: null,
      type: Object,
      required: false,
    },
  },

  computed: {
    failedValidations() {
      const ret = [];
      const loop = function (base, keychain = []) {
        if (base.$invalid === false) return;
        const keys = Object.keys(base).filter(it => it.charAt(0) !== '$' || ['$iter', '$each'].includes(it));
        keys.forEach((key) => {
          loop(base[key], [...keychain, key]);
        });
        if (isEmpty(keys) && base === false) {
          ret.push(keychain.join('.'));
        }
      };

      loop(this.$v);
      return ret;
    },
    errors: function () {
      if (!isEmpty(this.parentErrors)) return this.parentErrors;

      const $vm = this;
      return {
        touch: function (fieldPath) {
          if (isEmpty($vm.$v || {})) return;
          const field = get($vm.$v || {}, fieldPath);
          if (isEmpty(field)) return;
          field.$touch();
        },
        getItemForFieldName: function (fieldPath) {
          if (isEmpty($vm.$v || {})) return null;
          const field = get($vm.$v || {}, fieldPath);
          if (isEmpty(field)) return null;
          return head(
            [field || {}]
              .filter(item => item.$anyError)
              .map(item => ({
                name: $vm.$hv__getFieldName(fieldPath, item),
                label: $vm.$hv__getFieldLabel(fieldPath, item),
                // label: this.label || this.name || item[0],
                validation: Object.entries(item)
                  .map(it => ({
                    name: it[0],
                    result: it[1],
                    params: (isNil(item.$params) ? { } : item.$params[it[0]]) || {},
                  }))
                  .filter(it => it.name.indexOf('$') !== 0)
                  .filter(it => it.result === false),
              }))
              .filter(it => !isEmpty(it.validation)),
          );
        },
        first: function (fieldName) {
          return this.getErrorMessage(this.getItemForFieldName(fieldName));
        },
        getErrorMessage: function (field) {
          if (isEmpty(field)) return null;
          const errorMessages = field.validation
            .map((it) => {
              if (!isNil(it.params) && !isEmpty(it.params.message)) return it.params.message;
              else return $vm.$t(`ValidationError.${(isNil(it.params) ? null : it.params.message_key) || it.name}`, { field: field.label, ...(it.params || {}) });
            });

          return head(errorMessages) || $vm.$t('ValidationError.invalid', [field.label]);
        },
      };
    },
  },

  methods: {
    $hv__getFieldName(fieldPath, item) {
      return fieldPath;
    },
    $hv__getFieldLabel(fieldPath, item) {
      return (isEmpty(item.$params.label) ? null : item.$params.label.label) || fieldPath;
    },
    $hv__createValidators: function (validate, label = null) {
      if (isEmpty(validate)) return {};

      let ret = {};
      const parts = split(validate.replaceAll(/([^\\])\|/g, '$1\u000B').replaceAll('\\|', '|'), '\u000B');
      parts.forEach((part) => {
        const validation = split(part, ':');
        const key = validation[0];
        const value = validation.length > 1 ? part.slice(part.indexOf(':') + 1) : null;

        ret = {
          ...ret,
          ...(this.$hv__createValidator(key, value)),
        };
      });

      if (!isEmpty(label)) {
        ret.label = helpers.withParams(
          { label: label },
          () => true,
        );
      }

      return ret;
    },
    $hv__createValidator: function (key, value = null) {
      const ret = {};
      switch (key) {
        case 'required':
          ret.required = required;
          break;
        case 'email':
          ret.email = email;
          break;
        case 'min_length':
          ret.minValue = helpers.withParams(
            { length: parseInt(value, 10), message_key: 'min' },
            minLength(parseInt(value, 10)),
          );
          break;
        case 'max_length':
          ret.maxLength = helpers.withParams(
            { length: parseInt(value, 10), message_key: 'max' },
            maxLength(parseInt(value, 10)),
          );
          break;
        case 'min_value':
          ret.minValue = helpers.withParams(
            { min: parseInt(value, 10), message_key: 'min_value' },
            minValue(parseInt(value, 10)),
          );
          break;
        case 'max_value':
          ret.maxValue = helpers.withParams(
            { max: parseInt(value, 10), message_key: 'max_value' },
            maxValue(parseInt(value, 10)),
          );
          break;
        case 'not_value':
          ret.not_value = helpers.withParams(
            { not: parseInt(value, 10), message_key: 'not_value' },
            not(model => model === parseInt(value, 10)),
          );
          break;
        case 'same_as':
          ret.sameAs = helpers.withParams(
            { message_key: 'same_as' },
            _value => get(this, value) === _value || (isEmpty(get(this, value)) && isEmpty(_value)),
          );
          break;
        case 'birthdate':
          ret.birthdate = helpers.withParams(
            { message_key: 'birthdate' },
            (_value) => {
              if (this.$moment(_value, 'YYYYMMDD').isAfter(this.$moment())) return false;
              if (this.$moment(_value, 'YYYYMMDD').isBefore(this.$moment('19050101', 'YYYYMMDD'))) return false;
              return true;
            },
          );
          break;
        case 'numeric':
          ret.numeric = numeric;
          break;
        case 'decimal':
          ret.decimal = helpers.withParams(
            { message_key: 'numeric' },
            decimal(),
          );
          break;
        case 'integer':
          ret.integer = integer;
          break;
        case 'regex':
          ret.regex = helpers.regex('regex', new RegExp(value));
          break;
        default:
          // do nothing
          break;
      }

      return ret;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ValidateMixin.js